module.exports = __webpack_public_path__ + "static/media/facebook.c509a4c4.svg";